import type { PublicApiKey } from '@/apilib';
import type { createDuplicatePageCodeConditionApi } from './createDuplicatePageCodeConditionApi';

export const DuplicatePageCodeConditionApiKey: PublicApiKey<
  typeof createDuplicatePageCodeConditionApi
> = {
  name: 'DuplicatePageCodeConditionApi',
  public: true,
};
